import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AdminDashboard from "../AdminDashboard";
import { Alert, Dropdown, Spinner, Table } from "react-bootstrap";

import { basicConfigMultipart } from "../../../constants";
import axios from "axios";
import { localizeDate } from "../../../methods/formatDate";
import { Check, ThreeDots, X } from "react-bootstrap-icons";

const CustomerOrders = () => {
  const { pk } = useParams();

  const [loading, setLoading] = useState(true);

  const [showError, setShowError] = useState(false);

  const [ordersList, setOrdersList] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      setShowError(false);
      setLoading(true);

      await axios
        .post(
          `${process.env.REACT_APP_API_URL}/orders/filter_order/`,
          {
            customer: pk,
          },
          basicConfigMultipart
        )
        .catch((_) => {
          setShowError(true);
        })
        .then((response) => {
          if (response && response.status === 200) {
            setOrdersList(response.data);
          } else {
            setShowError(true);
          }
        });

      setLoading(false);
    };

    fetchOrders();
  }, [pk]);

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Customer's Orders</h4>
          </div>

          <div className="admin_content_content">
            <Table striped hover>
              <thead>
                <tr>
                  <th>#Id</th>
                  <th>Customer</th>
                  <th>Date Created</th>
                  <th>Status</th>
                  <th>Total</th>
                  <th>Paid</th>
                  <th>Shipping</th>
                  <th>Line Items</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ordersList.map((order, index) => {
                  return (
                    <tr key={index}>
                      <td>{order?.id}</td>
                      <td>
                        <Link to={`/admin/orders/${order?.customer}`}>
                          {order?.customer}
                        </Link>
                      </td>
                      <td>{localizeDate(order?.date_created_gmt)}</td>
                      <td
                        style={{
                          color:
                            order?.status === "pending"
                              ? "orange"
                              : order?.status === "completed"
                              ? "green"
                              : "black",
                        }}
                      >
                        {order?.status}
                      </td>
                      <td>{order?.total}</td>
                      <td>
                        {!(order?.needs_payment ?? true) &&
                        order?.date_paid_gmt !== null ? (
                          <Check />
                        ) : (
                          <X color="red" />
                        )}
                      </td>
                      <td>{order?.shipping != null && <Check />}</td>
                      <td>{(order?.line_items ?? []).length}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle>
                            <ThreeDots />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              as={Link}
                              role=""
                              to={`/admin/orders/order/${order?.id}`}
                            >
                              View Order
                            </Dropdown.Item>
                            {order?.status === "pending" && (
                              <Dropdown.Item>Cancel Order</Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default CustomerOrders;
